/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Magic_Link_Generate_FailedInputs */

const en_magic_link_generate_failed = /** @type {(inputs: Magic_Link_Generate_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to generate magic link`)
};

const es_magic_link_generate_failed = /** @type {(inputs: Magic_Link_Generate_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo generar el link magico`)
};

/**
* | output |
* | --- |
* | "Failed to generate magic link" |
*
* @param {Magic_Link_Generate_FailedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const magic_link_generate_failed = /** @type {((inputs?: Magic_Link_Generate_FailedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Magic_Link_Generate_FailedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_magic_link_generate_failed(inputs)
	return es_magic_link_generate_failed(inputs)
});